import React from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./Styles";
import CustomizedSelect from "../common/CustomizedSelect";
import userActions from "./actions";
import { useSelector } from "react-redux";

const FilterTogglebar = () => {
  const classes = useStyles();
  const { setScenario } = userActions();
  const { scenario } = useSelector((state) => state.central_arizona);

  const scenario_options = [
    { label: "Drought Contingency Plan Stages", value: "DCP Cuts" },
    { label: "More Severe", value: "Deeper Cuts" },
  ];

  const handleSelectedScenario = (e) => {
    setScenario(e.target.value);
  };

  return (
    <Grid container classes={{ root: classes.filterContainer }}>
      <CustomizedSelect
        label="Scenario"
        dropdownValue={scenario}
        options={scenario_options}
        handleSelectedItem={handleSelectedScenario}
      />
    </Grid>
  );
};

export default FilterTogglebar;
